import React from "react";
import styles from "./Sidebar.module.css";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import { NavLink } from "react-router-dom";
import InventoryIcon from "@mui/icons-material/Inventory";
import AnalyticsIcon from "@mui/icons-material/Analytics";
import { Divider } from "@mui/material";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import LogoutIcon from "@mui/icons-material/Logout";
import SettingsIcon from "@mui/icons-material/Settings";
import ChatIcon from "@mui/icons-material/Chat";
import InfoIcon from "@mui/icons-material/Info";
import PaidIcon from "@mui/icons-material/Paid";
import RequestQuoteIcon from "@mui/icons-material/RequestQuote";
const Sidebar = () => {
  return (
    <div className={styles.container}>
      <h1 className={styles.logo}>LOGO</h1>
      <NavLink
        to="/"
        className={styles.over}
        style={({ isActive }) => ({
          borderLeft: isActive ? "4px solid blue" : "#545e6f",
          color: isActive ? "black" : "grey",
        })}
        exact="true"
      >
        <div style={{ display: "flex", alignItems: "center", width: "60%" }}>
          <AccountBalanceWalletIcon style={{ color: "grey" }} />
          <h3 style={{ marginLeft: "3%" }}>Overview</h3>
        </div>
      </NavLink>
      <NavLink
        to="/product"
        className={styles.over}
        style={({ isActive }) => ({
          borderLeft: isActive ? "4px solid blue" : "#545e6f",
          color: isActive ? "black" : "grey",
        })}
        exact="true"
      >
        <div style={{ display: "flex", alignItems: "center", width: "60%" }}>
          <InventoryIcon style={{ color: "grey" }} />
          <h3 style={{ marginLeft: "3%" }}>Products</h3>
        </div>
      </NavLink>
      <NavLink
        to="/analytics"
        className={styles.over}
        style={({ isActive }) => ({
          borderLeft: isActive ? "4px solid blue" : "#545e6f",
          color: isActive ? "black" : "grey",
        })}
        exact="true"
      >
        <div style={{ display: "flex", alignItems: "center", width: "60%" }}>
          <AnalyticsIcon style={{ color: "grey" }} />
          <h3 style={{ marginLeft: "3%" }}>Analytics</h3>
        </div>
      </NavLink>
      <NavLink
        to="/Schedule"
        className={styles.over}
        style={({ isActive }) => ({
          borderLeft: isActive ? "4px solid blue" : "#545e6f",
          color: isActive ? "black" : "grey",
        })}
        exact="true"
      >
        <div style={{ display: "flex", alignItems: "center", width: "60%" }}>
          <CalendarMonthIcon style={{ color: "grey" }} />
          <h3 style={{ marginLeft: "3%" }}>Schedule</h3>
        </div>
      </NavLink>
      <NavLink
        to="/Payout"
        className={styles.over}
        style={({ isActive }) => ({
          borderLeft: isActive ? "4px solid blue" : "#545e6f",
          color: isActive ? "black" : "grey",
        })}
        exact="true"
      >
        <div style={{ display: "flex", alignItems: "center", width: "60%" }}>
          <PaidIcon style={{ color: "grey" }} />
          <h3 style={{ marginLeft: "3%" }}>Payout</h3>
        </div>
      </NavLink>
      <NavLink
        to="/statement"
        className={styles.over}
        style={({ isActive }) => ({
          borderLeft: isActive ? "4px solid blue" : "#545e6f",
          color: isActive ? "black" : "grey",
        })}
        exact="true"
      >
        <div style={{ display: "flex", alignItems: "center", width: "60%" }}>
          <RequestQuoteIcon style={{ color: "grey" }} />
          <h3 style={{ marginLeft: "3%" }}>Statement</h3>
        </div>
      </NavLink>
      <Divider style={{ marginLeft: "8%", marginRight: "8%" }} />
      <NavLink
        to="/help"
        className={styles.over}
        style={({ isActive }) => ({
          borderLeft: isActive ? "4px solid blue" : "#545e6f",
          color: isActive ? "black" : "grey",
        })}
        exact="true"
      >
        <div style={{ display: "flex", alignItems: "center", width: "60%" }}>
          <InfoIcon style={{ color: "grey" }} />
          <h3 style={{ marginLeft: "3%" }}>Help</h3>
        </div>
      </NavLink>
      <NavLink
        to="/community"
        className={styles.over}
        style={({ isActive }) => ({
          borderLeft: isActive ? "4px solid blue" : "#545e6f",
          color: isActive ? "black" : "grey",
        })}
        exact="true"
      >
        <div style={{ display: "flex", alignItems: "center", width: "60%" }}>
          <ChatIcon style={{ color: "grey" }} />
          <h3 style={{ marginLeft: "3%" }}>Community</h3>
        </div>
      </NavLink>
      <NavLink
        to="/setting"
        className={styles.over}
        style={({ isActive }) => ({
          borderLeft: isActive ? "4px solid blue" : "#545e6f",
          color: isActive ? "black" : "grey",
        })}
        exact="true"
      >
        <div style={{ display: "flex", alignItems: "center", width: "60%" }}>
          <SettingsIcon style={{ color: "grey" }} />
          <h3 style={{ marginLeft: "3%" }}>Settings</h3>
        </div>
      </NavLink>
      <NavLink
        to="/logout"
        className={styles.over}
        style={({ isActive }) => ({
          borderLeft: isActive ? "4px solid blue" : "#545e6f",
          color: isActive ? "black" : "grey",
        })}
        exact="true"
      >
        <div style={{ display: "flex", alignItems: "center", width: "60%" }}>
          <LogoutIcon style={{ color: "grey" }} />
          <h3 style={{ marginLeft: "3%" }}>Logout</h3>
        </div>
      </NavLink>
    </div>
  );
};
export default Sidebar;
